/**
 * @todo move into service
 */
export default {
    computed: {
        searchUrl() {
            const store = this.store;
            const query = this.searchQuery;

            if (this.isAdminUser) {
                return store.search_url + query.replace(/ /g, '+');
            }

            return '/out/?s=' + store.id + '&q=' + encodeURIComponent(query);
        }
    },

    methods: {
        openSearch($event) {
            $event.preventDefault();
            $event.stopPropagation();

            window.open(this.searchUrl, '_blank');
        }
    }
};
